import { API } from "../config/axiosConfig";

export const addressModule = {
  // Get all addresses for the authenticated user
  getAddresses: async () => {
    try {
      const response = await API.get("/api/users/addresses/");
      return {
        success: true,
        data: response.data?.data || response.data?.details || [],
        message: response.data?.message || "Addresses fetched successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch addresses",
        error: error.response?.data || error,
      };
    }
  },

  // Add a new address
  addAddress: async (addressData) => {
    try {
      const response = await API.post("/api/users/addresses/add/", addressData);
      return {
        success: true,
        data: response.data?.data || response.data?.details || response.data,
        message: response.data?.message || "Address added successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to add address",
        error: error.response?.data || error,
      };
    }
  },

  // Update an existing address
  updateAddress: async (addressId, addressData) => {
    try {
      const response = await API.patch(
        `/api/users/addresses/${addressId}/update/`,
        addressData
      );
      return {
        success: true,
        data: response.data?.data || response.data?.details || response.data,
        message: response.data?.message || "Address updated successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to update address",
        error: error.response?.data || error,
      };
    }
  },

  // Delete an address
  deleteAddress: async (addressId) => {
    try {
      const response = await API.delete(
        `/api/users/addresses/${addressId}/delete/`
      );
      return {
        success: true,
        data: response.data,
        message: response.data?.message || "Address deleted successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to delete address",
        error: error.response?.data || error,
      };
    }
  },
};

export default addressModule;

